var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.70975 0.251194L9.69929 9.47264C10.1544 9.99486 10.8109 10.2989 11.4935 10.2989C12.1761 10.2989 12.8327 10.0015 13.2878 9.47264L21.1473 0.409842C21.2123 0.337128 21.2903 0.277635 21.3683 0.231362C21.0368 0.0859346 20.6662 0 20.2827 0H2.71738C2.34683 0 1.99579 0.0727139 1.67725 0.211531C1.69025 0.224752 1.70325 0.237973 1.71625 0.251194H1.70975Z",
    fill: "#FF8C0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.584 1.29565C22.5515 1.3882 22.4995 1.48074 22.428 1.56007L14.575 10.6229C13.7949 11.5219 12.6767 12.0375 11.5001 12.0375C10.3234 12.0375 9.20529 11.5219 8.42519 10.6229L0.435648 1.39481C0.435648 1.39481 0.409644 1.35515 0.396643 1.33532C0.14961 1.75177 0.0065918 2.23432 0.0065918 2.75654V15.2369C0.0065918 16.7639 1.22225 18 2.72395 18H20.2957C21.7974 18 23.0131 16.7639 23.0131 15.2369V2.76315C23.0131 2.2211 22.8571 1.72533 22.597 1.29565H22.584Z",
    fill: "#FF8C0B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d1c4bf51989badc250cac561a5324537.svg";
export { ForwardRef as ReactComponent };